import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bsc-it',
  templateUrl: './bsc-it.component.html',
  styleUrls: ['./bsc-it.component.scss']
})
export class BscItComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
